import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from "@material-ui/core/styles";
import clss from "classnames";
import React, { useState, useEffect } from "react";

const useStyles = makeStyles(() => ({
  bar: {
    display: "none",
    zIndex: "9999",
    position: "fixed",
    left: "0px",
    top: "0px",
    width: "100%",
    "&.MuiLinearProgress-colorPrimary": {
      backgroundColor: "rgba(66, 0, 100, 0.2)",
    },
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "rgba(255, 153, 0, 1)",
    },
  },
  barActive: {
    display: "block",
  },
}));

function Processing() {
  const classes = useStyles();

  const [active, setActive] = useState(false);

  useEffect(() => {
    const nativeOpenFunction = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function () {
      setActive(true);

      this.addEventListener("load", function () {
        setActive(false);
      });

      this.addEventListener("error", function () {
        setActive(false);
      });

      this.addEventListener("abort", function () {
        setActive(false);
      });

      nativeOpenFunction.apply(this, arguments);
    };
  }, []);

  return (
    <LinearProgress
      className={clss(classes.bar, { [classes.barActive]: active })}
    />
  );
}

export default Processing;
